import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getSwingListApi = async (payload) => {
    try {
        const { playerUid, sessionId, sessionToken } = payload
        const body = {
            "identity": "user.aca.getuserswingsbyid",
            "uid": playerUid,
            "sessionId": sessionId
        }
        const swingList = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await swingList.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}